import { Engineer } from "resource-planner-model";
import { InviteSaveResult } from "../utils/invitationStatus";
export const FETCH_ENGINEERS = "engineers/fetch";
export const LOAD_ENGINEERS = "engineers/load";
export const REMOVE_ENGINEER = "engineers/remove";
export const REMOVE_ENGINEER_LOCAL = "engineers/remove_local";
export const PERSIST_ENGINEER = "engineers/persist";
export const UPSERT_ENGINEER = "engineers/upsert";
export const SET_ENGINEER_JIRA_ACCESS = "engineers/jira/access";
export const SET_ENGINEER_CONFLUENCE_ACCESS = "engineers/confluence/access";

export interface EngineersState {
  items: { [id: string]: Engineer };
  loadedAll: boolean;
  nextToken?: string;
  synching: boolean;
}

export interface FetchEngineersAction {
  type: typeof FETCH_ENGINEERS;
  append?: boolean;
  limit?: number;
  nextToken?: string;
  paginated?: boolean;
}

export interface LoadEngineersAction {
  type: typeof LOAD_ENGINEERS;
  append?: boolean;
  items: Engineer[];
  loadedAll?: boolean;
  nextToken?: string;
}

export interface RemoveEngineerAction {
  type: typeof REMOVE_ENGINEER;
  id: string;
}

export interface RemoveEngineerLocalAction {
  type: typeof REMOVE_ENGINEER_LOCAL;
  id: string;
}

export interface PersistEngineerAction {
  type: typeof PERSIST_ENGINEER;
  item: Engineer;
}

export type PersistEngineerResult = InviteSaveResult<Engineer>;

export interface UpsertEngineerAction {
  type: typeof UPSERT_ENGINEER;
  item: Engineer;
}

export interface SetEngineerJiraAccessAction {
  type: typeof SET_ENGINEER_JIRA_ACCESS;
  id: string;
  callback?: () => void;
}

export interface SetEngineerConfluenceAccessAction {
  type: typeof SET_ENGINEER_CONFLUENCE_ACCESS;
  id: string;
  callback?: () => void;
}

export type EngineerAction =
  | FetchEngineersAction
  | LoadEngineersAction
  | RemoveEngineerLocalAction
  | RemoveEngineerAction
  | PersistEngineerAction
  | UpsertEngineerAction
  | SetEngineerJiraAccessAction
  | SetEngineerConfluenceAccessAction;
